import { featureFlag } from "config";

export const multipleBorrowersAreEnabled = (): boolean => featureFlag("enableMultipleBorrowers");

export const pullMultipleCreditReportsIsEnabled = (): boolean =>
  featureFlag("enablePullMultipleCreditReports");

export const fourBorrowersAreEnabled = (): boolean => featureFlag("enableFourBorrowers");
